/**
 * Storage keys
 */
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth_token',
  SESSION_ID: 'axflow_admin_session',
  USER: 'admin_user',
  LANGUAGE: 'app_language',
} as const

/**
 * Route paths
 */
export const ROUTES = {
  HOME: '/',
  LOGIN: '/auth/login',
  AUTH_CALLBACK: '/auth/callback',
  DASHBOARD: '/dashboard',
  HEALTH: '/health',
  AUDIT: '/audit',
  PRESENTATION: '/presentation',
  WORKFLOWS: '/workflows',
  EXECUTIONS: '/executions',
  MONITORING: '/monitoring',
  DEPLOYMENT: '/deployment',
  CONNECTORS: '/connectors',
  TEAMS: '/teams',
  TENANTS: '/tenants',
  USERS: '/users',
  INVITATIONS: '/invitations',
  TEMPLATES: '/templates',
  INFRA: '/infra',
  INFRA_REDIS: '/infra/redis',
  INFRA_SERVICE_BUS: '/infra/service-bus',
  INFRA_DB: '/infra/db/:schema',
  INFRA_DB_TABLE: '/infra/db/:schema/:table',
  WHATS_NEW: '/whats-new',
  FORBIDDEN: '/403',
  NOT_FOUND: '/404',
} as const
